import type { Locale } from '@diana/shared'

/**
 * Strings for the shared chrome (header, footer). Page copy lives next to
 * each page in the same `Record<Locale, …>` shape — co-located, so a page and
 * its translations always travel together.
 *
 * Brand voice is informal ("Ty") in all three languages, matching the Polish.
 */

type CommonStrings = {
  tagline: string
  nav: { about: string; learn: string; products: string; contact: string }
  bookLesson: string
  /** Header button shown only to Diana when she is signed in. */
  adminPanel: string
  menuOpen: string
  menuClose: string
  switchLanguage: string
  footer: {
    bio: string
    navigation: string
    start: string
    freeCall: string
    pricing: string
    panel: string
    terms: string
    privacy: string
    cookies: string
  }
}

export const COMMON: Record<Locale, CommonStrings> = {
  pl: {
    tagline: 'język polski',
    nav: {
      about: 'O mnie',
      learn: 'Ucz się ze mną',
      products: 'Produkty',
      contact: 'Kontakt',
    },
    bookLesson: 'Umów lekcję',
    adminPanel: 'Panel',
    menuOpen: 'Otwórz menu',
    menuClose: 'Zamknij menu',
    switchLanguage: 'Zmień język',
    footer: {
      bio: 'Uczę polskiego obcokrajowców, którzy chcą mówić naturalnie — nie recytować regułek. Indywidualnie, online, w tempie dopasowanym do Ciebie.',
      navigation: 'Nawigacja',
      start: 'Zaczynamy?',
      freeCall: 'Umów bezpłatną rozmowę',
      pricing: 'Cennik',
      panel: 'Panel',
      terms: 'Regulamin',
      privacy: 'Polityka prywatności',
      cookies: 'Cookies',
    },
  },
  uk: {
    tagline: 'польська мова',
    nav: {
      about: 'Про мене',
      learn: 'Навчання зі мною',
      products: 'Матеріали',
      contact: 'Контакт',
    },
    bookLesson: 'Записатися на урок',
    adminPanel: 'Панель',
    menuOpen: 'Відкрити меню',
    menuClose: 'Закрити меню',
    switchLanguage: 'Змінити мову',
    footer: {
      bio: 'Навчаю польської іноземців, які хочуть говорити природно — а не декламувати правила. Індивідуально, онлайн, у твоєму темпі.',
      navigation: 'Навігація',
      start: 'Починаємо?',
      freeCall: 'Записатися на безкоштовну розмову',
      pricing: 'Ціни',
      panel: 'Панель',
      terms: 'Умови користування',
      privacy: 'Політика конфіденційності',
      cookies: 'Файли cookie',
    },
  },
  ru: {
    tagline: 'польский язык',
    nav: {
      about: 'Обо мне',
      learn: 'Занятия со мной',
      products: 'Материалы',
      contact: 'Контакт',
    },
    bookLesson: 'Записаться на урок',
    adminPanel: 'Панель',
    menuOpen: 'Открыть меню',
    menuClose: 'Закрыть меню',
    switchLanguage: 'Сменить язык',
    footer: {
      bio: 'Учу польскому иностранцев, которые хотят говорить естественно — а не декламировать правила. Индивидуально, онлайн, в твоём темпе.',
      navigation: 'Навигация',
      start: 'Начинаем?',
      freeCall: 'Записаться на бесплатную встречу',
      pricing: 'Цены',
      panel: 'Панель',
      terms: 'Условия использования',
      privacy: 'Политика конфиденциальности',
      cookies: 'Файлы cookie',
    },
  },
}
